export default class EventsService {
  static async fetchEvents(month, year, token, calendarId) {
    const apiUrl = window.env.API_URL;
    let url = `${apiUrl}/api/v1/events/calendar-view?month=${month + 1}&year=${year}`;
    if (calendarId) url += `&calendarId=${calendarId}`;
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch events');
    return response.json();
  }

  static async saveEvent(event, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/events`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event),
    });
    if (!response.ok) {
      if (response.status === 409) {
        throw new Error('conflict met ander event');
      }
      throw new Error('Failed to save event');
    }
    return response.json();
  }

    static async updateEvent(event, token) {
        const apiUrl = window.env.API_URL;
        const response = await fetch(`${apiUrl}/api/v1/events/${event.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(event),
        });
        if (!response.ok) {
            if (response.status === 409) {
                throw new Error('conflict met ander event');
            }
            throw new Error('Failed to update event');
        }
        return response.json();
    }

    static async deleteEvent(eventId, token) {
        const apiUrl = window.env.API_URL;
        const response = await fetch(`${apiUrl}/api/v1/events/${eventId}`, {
        method: 'DELETE',
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        });
        if (!response.ok) throw new Error('Failed to delete event');
        return true;
        
    }

    static async uncoupleProjectedEvent(originalEvent, newEventData, token) {
        // Convert the day timestamp to yyyy-mm-dd format
        const skippedDate = new Date(originalEvent.day).toISOString().split('T')[0];
        
        // First, we need to find and update the ORIGINAL recurring event (not the projection)
        // The projection has the same ID as the original, but we need to update the base event
        // We need to preserve the original event's start date, not use the projected instance date
        const baseEvent = {
            id: originalEvent.id,
            title: originalEvent.title,
            description: originalEvent.description,
            phoneNumber: originalEvent.phoneNumber,
            startTime: originalEvent.startTime,
            endTime: originalEvent.endTime,
            // DON'T update the day - keep the original recurring event's start date
            // day: originalEvent.day, // This was the mistake - this contains the projected date
            label: originalEvent.label,
            calendarId: originalEvent.calendarId,
            recurrenceType: originalEvent.recurrenceType,
            recurrenceInterval: originalEvent.recurrenceInterval,
            recurrenceEndDate: originalEvent.recurrenceEndDate,
            skippedOccurrences: [
                ...(originalEvent.skippedOccurrences || []),
                skippedDate
            ]
        };
        
        await this.updateEvent(baseEvent, token);
        
        // Then create a new standalone event with empty ID for POST
        const standaloneEvent = {
            title: newEventData.title,
            description: newEventData.description,
            phoneNumber: newEventData.phoneNumber,
            startTime: newEventData.startTime,
            endTime: newEventData.endTime,
            day: newEventData.day,
            label: newEventData.label,
            calendarId: newEventData.calendarId,
            recurrenceType: 'NONE',
            recurrenceInterval: null,
            recurrenceEndDate: null,
            skippedOccurrences: null
        };
        
        return await this.saveEvent(standaloneEvent, token);
    }

    static async skipProjectedEvent(originalEvent, token) {
        // Convert the day timestamp to yyyy-mm-dd format
        const skippedDate = new Date(originalEvent.day).toISOString().split('T')[0];
        
        // Update the original recurring event to add the skipped occurrence
        const baseEvent = {
            id: originalEvent.id,
            title: originalEvent.title,
            description: originalEvent.description,
            phoneNumber: originalEvent.phoneNumber,
            startTime: originalEvent.startTime,
            endTime: originalEvent.endTime,
            // DON'T update the day - keep the original recurring event's start date
            label: originalEvent.label,
            calendarId: originalEvent.calendarId,
            recurrenceType: originalEvent.recurrenceType,
            recurrenceInterval: originalEvent.recurrenceInterval,
            recurrenceEndDate: originalEvent.recurrenceEndDate,
            skippedOccurrences: [
                ...(originalEvent.skippedOccurrences || []),
                skippedDate
            ]
        };
        
        return await this.updateEvent(baseEvent, token);
    }

}
